module.exports = __webpack_public_path__ + "static/media/Videoicon.b8725873.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/socialIcons/Videoicon.png
// module id = 759
// module chunks = 0